const routes = [
  {
    path: 'cellwise-production-dashboard', // cellwise-production-dashboard
    component: () => import(/* webpackChunkName: "cellwise-production-dashboard" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'cellwiseProductionDashboard', // cellwiseProductionDashboard
        component: () => import(/* webpackChunkName: "cellwise-production-dashboard" */ './views/CellwiseProductionDashboard.vue'),
      },
    ],
  },
];

export default routes;
